import { render } from "./CartList.vue?vue&type=template&id=32e2d2fe"
import script from "./CartList.vue?vue&type=script&lang=js"
export * from "./CartList.vue?vue&type=script&lang=js"
script.render = render

export default script